"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteViewSnapshots = exports.siteViewEditorList = exports.siteViewConfig = exports.siteUpdate = exports.siteUnlock = exports.siteSuccess = exports.siteSubmit = exports.siteSoftDeleteRestore = exports.siteSoftDeleteList = exports.siteSoftDelete = exports.siteSave = exports.siteResetWithoutList = exports.siteResetEditorlock = exports.siteResetEditorUnlock = exports.siteReset = exports.siteRead = exports.sitePlay = exports.sitePause = exports.siteLock = exports.siteListReviewAndApproval = exports.siteList = exports.siteFilter = exports.siteError = exports.siteEditorUnlock = exports.siteEditorLock = exports.siteEditSaveReset = exports.siteEditSave = exports.siteEdit = exports.siteDownloadEmail = exports.siteDeleteReset = exports.siteDelete = exports.siteCopyUrl = exports.siteClone = exports.siteChangeReset = exports.siteChange = exports.siteBuildList = exports.siteApprove = exports.siteAdd = void 0;
var _site = require("./site.constant");
// @flow

// common success
var siteSuccess = function siteSuccess(actionType, data) {
  return {
    type: _site.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.siteSuccess = siteSuccess;
var siteError = function siteError(actionType, error) {
  return {
    type: _site.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteError = siteError;
var siteAdd = function siteAdd(payload) {
  return {
    type: _site.actionTypes.ADD,
    payload: payload
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteAdd = siteAdd;
var siteEditSave = function siteEditSave(payload) {
  return {
    type: _site.actionTypes.EDIT_SAVE,
    payload: payload
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteEditSave = siteEditSave;
var siteEditSaveReset = function siteEditSaveReset(payload) {
  return {
    type: _site.actionTypes.EDIT_SAVE_RESET,
    payload: payload
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteEditSaveReset = siteEditSaveReset;
var siteEdit = function siteEdit(payload) {
  return {
    type: _site.actionTypes.EDIT,
    payload: payload
  };
};

/**
 * read site
 * @param payload
 * @returns api response
 * @description this function used to read site.
 */
exports.siteEdit = siteEdit;
var siteRead = function siteRead(payload) {
  return {
    type: _site.actionTypes.READ,
    payload: payload
  };
};

/**
 * change site
 * @param payload
 * @returns api response
 * @description this function used to change site.
 */
exports.siteRead = siteRead;
var siteChange = function siteChange(payload) {
  return {
    type: _site.actionTypes.CHANGE,
    payload: payload
  };
};

/**
 * change site
 * @param payload
 * @returns api response
 * @description this function used to change site.
 */
exports.siteChange = siteChange;
var siteChangeReset = function siteChangeReset() {
  return {
    type: _site.actionTypes.RESET_CHANGE
  };
};

/**
 * update site
 * @param payload
 * @returns api response
 * @description this function used to update site.
 */
exports.siteChangeReset = siteChangeReset;
var siteUpdate = function siteUpdate(payload) {
  return {
    type: _site.actionTypes.UPDATE,
    payload: payload
  };
};

/**
 * list of site
 * @param payload
 * @returns api response
 * @description this function used to list of site.
 */
exports.siteUpdate = siteUpdate;
var siteList = function siteList(payload) {
  return {
    type: _site.actionTypes.LIST,
    payload: payload
  };
};

/**
 * list of site
 * @param payload
 * @returns api response
 * @description this function used to list of site.
 */
exports.siteList = siteList;
var siteListReviewAndApproval = function siteListReviewAndApproval(payload) {
  return {
    type: _site.actionTypes.LIST_REVIEW_APPROVAL,
    payload: payload
  };
};

/**
 * submit site
 * @param payload
 * @returns api response
 * @description this function used to submit site.
 */
exports.siteListReviewAndApproval = siteListReviewAndApproval;
var siteSubmit = function siteSubmit(payload) {
  return {
    type: _site.actionTypes.SUBMIT,
    payload: payload
  };
};

/**
 * approve site
 * @param payload
 * @returns api response
 * @description this function used to approve site.
 */
exports.siteSubmit = siteSubmit;
var siteApprove = function siteApprove(payload) {
  return {
    type: _site.actionTypes.APPROVE,
    payload: payload
  };
};

/**
 * delete site
 * @param payload
 * @returns api response
 * @description this function used to delete site.
 */
exports.siteApprove = siteApprove;
var siteDelete = function siteDelete(payload) {
  return {
    type: _site.actionTypes.DELETE,
    payload: payload
  };
};

/**
 * delete site
 * @param payload
 * @returns api response
 * @description this function used to delete site.
 */
exports.siteDelete = siteDelete;
var siteDeleteReset = function siteDeleteReset(payload) {
  return {
    type: _site.actionTypes.DELETE_RESET,
    payload: payload
  };
};

/**
 * clone site
 * @param payload
 * @returns api response
 * @description this function used to clone site.
 */
exports.siteDeleteReset = siteDeleteReset;
var siteClone = function siteClone(payload) {
  return {
    type: _site.actionTypes.CLONE,
    payload: payload
  };
};

/**
 * save site
 * @param payload
 * @returns api response
 * @description this function used to save site.
 */
exports.siteClone = siteClone;
var siteSave = function siteSave(payload) {
  return {
    type: _site.actionTypes.SAVE,
    payload: payload
  };
};

/**
 * build list site
 * @param payload
 * @returns api response
 * @description this function used to build list site.
 */
exports.siteSave = siteSave;
var siteBuildList = function siteBuildList(payload) {
  return {
    type: _site.actionTypes.BUILD_LIST,
    payload: payload
  };
};

/**
 * filter of site
 * @param payload
 * @returns api response
 * @description this function used to filter of site.
 */
exports.siteBuildList = siteBuildList;
var siteFilter = function siteFilter(payload) {
  return {
    type: _site.actionTypes.FILTER,
    payload: payload
  };
};

/**
 * pause site
 * @param payload
 * @returns api response
 * @description this function used to pause site.
 */
exports.siteFilter = siteFilter;
var sitePause = function sitePause(payload) {
  return {
    type: _site.actionTypes.PAUSE,
    payload: payload
  };
};

/**
 * play site
 * @param payload
 * @returns api response
 * @description this function used to play site.
 */
exports.sitePause = sitePause;
var sitePlay = function sitePlay(payload) {
  return {
    type: _site.actionTypes.PLAY,
    payload: payload
  };
};

/**
 * copy url of site
 * @param payload
 *
 * @returns api response
 * @description this function used to copy url of site.
 */
exports.sitePlay = sitePlay;
var siteCopyUrl = function siteCopyUrl(payload) {
  return {
    type: _site.actionTypes.COPY_URL,
    payload: payload
  };
};

/**
 * email
 * @param payload
 * @returns api response
 * @description this function used to email.
 */
exports.siteCopyUrl = siteCopyUrl;
var siteDownloadEmail = function siteDownloadEmail(payload) {
  return {
    type: _site.actionTypes.DOWNLOAD_EMAIL,
    payload: payload
  };
};

/**
 * lock site
 * @param payload
 * @returns api response
 * @description this function used to lock site.
 */
exports.siteDownloadEmail = siteDownloadEmail;
var siteLock = function siteLock(payload) {
  return {
    type: _site.actionTypes.LOCK,
    payload: payload
  };
};

/**
 * unlock site
 * @param payload
 * @returns api response
 * @description this function used to unlock site.
 */
exports.siteLock = siteLock;
var siteUnlock = function siteUnlock(payload) {
  return {
    type: _site.actionTypes.UNLOCK,
    payload: payload
  };
};

/**
 * lock site
 * @param payload
 * @returns api response
 * @description this function used to editor lock site.
 */
exports.siteUnlock = siteUnlock;
var siteEditorLock = function siteEditorLock(payload) {
  return {
    type: _site.actionTypes.EDITORLOCK,
    payload: payload
  };
};

/**
 * unlock site
 * @param payload
 * @returns api response
 * @description this function used to editor unlock site.
 */
exports.siteEditorLock = siteEditorLock;
var siteEditorUnlock = function siteEditorUnlock(payload) {
  return {
    type: _site.actionTypes.EDITORUNLOCK,
    payload: payload
  };
};
exports.siteEditorUnlock = siteEditorUnlock;
var siteResetEditorUnlock = function siteResetEditorUnlock(payload) {
  return {
    type: _site.actionTypes.RESET_EDITORUNLOCK,
    payload: payload
  };
};
exports.siteResetEditorUnlock = siteResetEditorUnlock;
var siteResetEditorlock = function siteResetEditorlock(payload) {
  return {
    type: _site.actionTypes.RESET_EDITORLOCK,
    payload: payload
  };
};

/**
 * view snapshots
 * @param payload
 * @returns api response
 * @description this function used to view snapshots.
 */
exports.siteResetEditorlock = siteResetEditorlock;
var siteViewSnapshots = function siteViewSnapshots(payload) {
  return {
    type: _site.actionTypes.VIEW_SNAPSHOTS,
    payload: payload
  };
};

/**
 * view editos of site
 * @param payload
 * @returns api response
 * @description this function used to view editos of site.
 */
exports.siteViewSnapshots = siteViewSnapshots;
var siteViewEditorList = function siteViewEditorList(payload) {
  return {
    type: _site.actionTypes.VIEW_EDITOR_LIST,
    payload: payload
  };
};

/**
 * view config of site
 * @param payload
 * @returns api response
 * @description this function used to view config of site.
 */
exports.siteViewEditorList = siteViewEditorList;
var siteViewConfig = function siteViewConfig(payload) {
  return {
    type: _site.actionTypes.VIEW_CONFIG,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.siteViewConfig = siteViewConfig;
var siteReset = function siteReset(payload) {
  return {
    type: _site.actionTypes.RESET,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.siteReset = siteReset;
var siteResetWithoutList = function siteResetWithoutList(payload) {
  return {
    type: _site.actionTypes.RESET_WITHOUT_LIST,
    payload: payload
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete.
 */
exports.siteResetWithoutList = siteResetWithoutList;
var siteSoftDelete = function siteSoftDelete(payload) {
  return {
    type: _site.actionTypes.SOFT_DELETE,
    payload: payload
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft delete restore.
 */
exports.siteSoftDelete = siteSoftDelete;
var siteSoftDeleteRestore = function siteSoftDeleteRestore(payload) {
  return {
    type: _site.actionTypes.SOFT_DELETE_RESTORE,
    payload: payload
  };
};

/**
 * soft delete list
 * @param payload
 * @returns api response
 * @description this function used to soft delete list.
 */
exports.siteSoftDeleteRestore = siteSoftDeleteRestore;
var siteSoftDeleteList = function siteSoftDeleteList(payload) {
  return {
    type: _site.actionTypes.SOFT_DELETE_LIST,
    payload: payload
  };
};
exports.siteSoftDeleteList = siteSoftDeleteList;